import * as type from '../actions/types';

const initialState = {
    loading: false,
    error: null,
}

export default function deleteBid(state = initialState, action) {
    switch (action.type) {
        case type.DELETE_BID_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.DELETE_BID_SUCCESS:
            return {
                ...state,
                loading: false,
            }
        case type.DELETE_BID_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}